
import { EMode, TSeoKeywordData } from '@microfrontends/app-shell-v2'
import { ELanguage } from '@microfrontends/react-components'
import CompanyListPage from '../../components/CompanyListPage'
import { IAuthUser } from '../../services/authService'
import { ICompanyListResponse } from '../../services/companyListService'
import { getServerSideProps } from '../../ssr/companyList'
import { AppStoreProvider } from '../../store'

export interface TPageProps {
  jsToken: string
  wsToken: string
  user: IAuthUser
  keyword: string
  industries: number[]
  companyList: ICompanyListResponse[]
  appMode: EMode
  seoKeywords: TSeoKeywordData[]
}

const CompanyDetailPage = (props: TPageProps) => {
  const { jsToken, wsToken, user, appMode, companyList, keyword = '', industries = [], seoKeywords } = props

  return (
    <AppStoreProvider langCode={ELanguage.EN}>
        <CompanyListPage
          seoKeywords={seoKeywords}
          jsToken={jsToken}
          wsToken={wsToken}
          companyList={companyList}
          keywordFromUrl={keyword}
          industriesFromUrl={industries}
          langCode={ELanguage.EN}
          user={user}
          appMode={appMode}
        />
    </AppStoreProvider>
  )
}

export default CompanyDetailPage

export { getServerSideProps }
